import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent {
  @Input() titleText: string = '';
  @Input() disable: boolean = false;

  @Input() panelOpenState: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  onExpensionChange() {
    if (!this.disable) {
      this.panelOpenState = !this.panelOpenState;
      setTimeout(() => {      
        window.dispatchEvent(new Event('resize'));      
      }, 500);
    }
  }
}
